export const applicationId = 5;

